import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

// Redirects home when an admin has fully disabled a standard page via
// Settings > Navigation & Pages. Renders children optimistically until
// settings load so normal page loads never wait on this check.
const PageGate = ({ pageKey, children }) => {
  const settings = useSelector((state) => state.website.settings);
  if (settings?.pageVisibility?.[pageKey] === false) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default PageGate;
